import React, { useState, useEffect } from 'react';
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { editCellContainerStyle } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import moment from "moment";
import { Tooltip } from "@mui/material";
import ALoader from "views/pages/manage/common/a-loader";

const ListComponent = ({
    loader,
    currentPage = 0,
    currPageSize,
    rowCount,
    nextButtonHandler,
    rows,
}) => {

    const [rowModesModel, setRowModesModel] = useState({});
    const [rowData, setRowData] = useState(rows);

    useEffect(() => setRowData(rows), [rows]);

    const columns = [
        new AGridColDef("event", "Events", false)
            .setMinWidth(100)
            .editable(true)
            .setFlex(2)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container `} >
                        {params?.value}
                    </div>
                </Tooltip> : <div>-</div>
            )),
        new AGridColDef("oldValue", "Old Value", false)
            .setMinWidth(170)
            .editable(true)
            .setFlex(2)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container `} >
                        {params?.value}
                    </div>
                </Tooltip> : <div>-</div>
            )),
        new AGridColDef("newValue", "New Value", false)
            .setMinWidth(170)
            .editable(true)
            .setFlex(2)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container `} >
                        {params?.value}
                    </div>
                </Tooltip> : <div>-</div>
            )),
        new AGridColDef("createdOn", "Created On", true)
            .setMinWidth(260)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={`${moment(params.value).format('DD-MM-YYYY')} at ${moment(params.value).format('hh:mm A')} by ${params.row.createdBy} `}>
                    <div className={`ellipsis-text-container`}>{`${moment(params.value).format('DD-MM-YYYY')} at ${moment(params.value).format('hh:mm A')}  ${params?.row?.createdBy ? `by ${params?.row?.createdBy}` : ''}`}</div>
                </Tooltip> : <div>-</div>
            )),
        new AGridColDef("updatedOn", "Updated On", true)
            .setMinWidth(260)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={`${moment(params.value).format('DD-MM-YYYY')} at ${moment(params.value).format('hh:mm A')} by ${params.row.updatedBy} `}>
                    <div className={`ellipsis-text-container`}>{`${moment(params.value).format('DD-MM-YYYY')} at ${moment(params.value).format('hh:mm A')}  ${params?.row?.updatedBy ? `by ${params?.row?.updatedBy}` : ''}`}</div>
                </Tooltip> : <div>-</div>
            )),
    ];

    return (
        <>
            {loader && <ALoader position="fixed" />}

            <div className="mt-3">
                <ADataGrid
                    removeWrapperContainer
                    rowModesModel={rowModesModel}
                    rows={rowData || []}
                    columns={columns}
                    rowId={(row) => row?.id}
                    rowHeight={50}
                    rowCount={rowCount}
                    loading={false}
                    currentPage={currentPage}
                    nextButtonHandler={nextButtonHandler}
                    sx={{
                        ...gridStyles,
                    }}
                    autoHeight
                    paginationModel={{ page: currentPage, pageSize: currPageSize }}
                />
            </div>
        </>
    )
}

export default ListComponent;